export default {
  countryCode: 'NZ',
  regionLinks: [
    {
      title: 'Whangarei',
    },
    {
      title: 'Hibiscus Coast',
    },
    {
      title: 'Auckland',
    },
    {
      title: 'Waikato',
    },
    {
      title: 'Taupo',
    },
    {
      title: 'Rotorua',
    },
    {
      title: 'Bay Of Plenty',
    },
    {
      title: 'Taranaki',
    },
    {
      title: 'Gisborne',
    },
    {
      title: "Hawke's Bay",
    },
    {
      title: 'Ohakune',
    },
    {
      title: 'Manawatu',
    },
    {
      title: 'Whanganui',
    },
    {
      title: 'Wairarapa',
    },
    {
      title: 'Wellington',
    },
    {
      title: 'Marlborough',
    },
    {
      title: 'Nelson',
    },
    {
      title: 'West Coast',
    },
    {
      title: 'Canterbury',
    },
    {
      title: 'Christchurch',
    },
    {
      title: 'Queenstown',
      slug: '/queenstown-lakes/',
    },
    {
      title: 'Wanaka',
    },
    {
      title: 'Otago',
    },
    {
      title: 'Southland',
    },
  ],
};
